
export const GlobalUtils = () => {
    const getStoreValue = (key: string, journeyStoreRef: any, defVal?: any) => {
        if (journeyStoreRef && journeyStoreRef[key])
            return journeyStoreRef[key];
        return defVal;
    }

    return {
        getStoreValue
    }
}

export const getSignatureByIndex = (signatures: any, seq: any) => {
    if (!signatures)
        return false;
    return signatures?.find((s: any) => s.sequence === seq)
}

export function dataURItoBlob(dataURI: any) {
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: 'image/png' });
}
